var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutubeSm(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6249 2.88025C17.5229 2.51667 17.3244 2.18751 17.0504 1.92775C16.7686 1.66 16.4232 1.46847 16.0469 1.37125C14.6384 0.999996 8.99535 0.999996 8.99535 0.999996C6.64285 0.973231 4.29092 1.09095 1.95285 1.3525C1.57649 1.45691 1.23177 1.65271 0.949352 1.9225C0.671852 2.1895 0.470852 2.51875 0.365852 2.8795C0.113622 4.2383 -0.00892845 5.618 -0.000147464 7C-0.00914746 8.38075 0.113103 9.76 0.365852 11.1205C0.468602 11.4797 0.668852 11.8075 0.947102 12.0722C1.22535 12.337 1.57185 12.5282 1.95285 12.6295C3.3801 13 8.99535 13 8.99535 13C11.3508 13.0268 13.7058 12.9091 16.0469 12.6475C16.4232 12.5503 16.7686 12.3587 17.0504 12.091C17.3243 11.8313 17.5226 11.5021 17.6241 11.1385C17.8829 9.78021 18.0088 8.39994 17.9998 7.01725C18.0193 5.6287 17.8936 4.24192 17.6249 2.8795V2.88025ZM7.20135 9.568V4.43275L11.8964 7.00075L7.20135 9.568Z",
    fill: "black",
    fillOpacity: 0.3
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeSm);
export default __webpack_public_path__ + "static/media/youtube-sm.fb266f87ad24592ca0f8450d20427b36.svg";
export { ForwardRef as ReactComponent };